<div class="md-block" *ngIf="text">
	<div class="md-block-font" *ngIf="icon">
		<i [ngClass]="icon"></i>
	</div>
	{{ text }}
</div>
